module.exports = __webpack_public_path__ + "img/about_map_route.a51d49af.png";